import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { of } from 'rxjs';

import { ListService } from '@fry/lib/list';
import { VenuesSearch, VenuesStore } from '@fry/booking/lib/venues';
import { EASLinkAction } from '@fry/components/common/buttons/buttons.service';


@Component({
    selector: 'eas-venue-list',
    templateUrl: './venue-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VenueListComponent implements OnInit {

  public items = this.list.items;
  public actions: EASLinkAction[] = [{
    type: 'link',
    label: $localize `New venue`,
    condition: () => {
      return of(true);
    },
    link: of(['add']),
    color: 'primary',
  }];

  constructor(
    private store: VenuesStore,
    private search: VenuesSearch,
    private list: ListService
  ) { }

  ngOnInit() {
    this.list.setupWith(this.store, this.search).subscribe();
    this.list.searchModel = {
      filter: {},
      sort: { sort_on: 'name', sort_order: 'asc' }
    };
  }
}
